"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, ReactNode } from "react";
type NewRoomListingContextValue = {
  adminTargetUserId?: string;
};
const NewRoomListingContext = createContext<NewRoomListingContextValue>({});
export function NewRoomListingContextProvider(t0) {
  const $ = _c(5);
  const {
    adminTargetUserId,
    children
  } = t0;
  let t1;
  if ($[0] !== adminTargetUserId) {
    t1 = {
      adminTargetUserId
    };
    $[0] = adminTargetUserId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <NewRoomListingContext.Provider value={t1} data-sentry-element="NewRoomListingContext.Provider" data-sentry-component="NewRoomListingContextProvider" data-sentry-source-file="NewRoomListingContext.tsx">{children}</NewRoomListingContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function useNewRoomListingContext() {
  return useContext(NewRoomListingContext);
}